import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { useLoadUserQuery } from "./features/api/authApi";
import './App.css';

// Public Pages
import Login from './pages/Login';
import HeroSection from './layout/homepage/HeroSection';
import PopularService from './layout/homepage/PopularService';
import HomeAbout from './layout/homepage/HomeAbout';
import MainLayout from './layout/MainLayout';
import PageView from "./pages/admin/pagecontent/PageView";
import PostView from "./pages/admin/postcontent/PostView";
import BlogList from "./pages/admin/postcontent/BlogList";
import Testimonial from "./pages/webpages/Testimonial";
import ContactUs from "./pages/webpages/ContactUs";
import MockTestsPage from "./pages/webpages/mock";
import MyLearning from './pages/student/MyLearning';
import Sidebar from './layout/Sidebar';
import AdminDashboard from './pages/admin/dashboard/Dashboard';
import CoursesList from './pages/admin/course/CoursesList';
import CreateCourse from './pages/admin/course/CreateCourse';

import PagesList from './pages/admin/pagecontent/PagesList';
import CreatePage from './pages/admin/pagecontent/CreatePage';
import EditPage from './pages/admin/pagecontent/EditPage';
import PostsList from './pages/admin/postcontent/PostsList';
import CreatePost from './pages/admin/postcontent/CreatePost';
import EditPost from './pages/admin/postcontent/EditPost';
import NewsFlashAdmin from "./pages/admin/newsflash/NewsFlashAdmin";
import EmailDashboard from './pages/admin/mails/EmailDashboard';
import CreateUser from "./pages/admin/users/CreateUser";
import EditUser from "./pages/admin/users/EditUser";
import UserList from "./pages/admin/users/UserList";
import SupportList from "./pages/admin/supporttickets/SupportList";
import SupportTicketForm from "./pages/admin/supporttickets/SupportTicketForm";
import InvoiceForm from "./pages/admin/Invoice/InvoiceForm";
import InvoiceList from "./pages/admin/Invoice/InvoiceList";
import InvoiceEdit from "./pages/admin/Invoice/InvoiceEdit";
import Attendance from "./pages/admin/Attendance/Attendance";
import AddNewLeads from "./pages/admin/leadform/AddNewLeads";
import LeadList from "./pages/admin/leadform/LeadList";
import OrdersList from "./pages/admin/orders/ordersList";
import CheckoutPage from './pages/CheckoutPage';
import Unit1A from './assets/AllCourses/DIY/Unit1A';
import BecomePartnerForm from './pages/BecomePartnerForm';
import PartnerList from './pages/admin/Partner/PartnerList';
import CreatePartner from './pages/admin/Partner/CreatePartner';
import EditPartnerDetails from './pages/admin/Partner/EditPartnerDetails';
// import BookAppointment from './pages/webpages/BookAppointment';
import EditLead from './pages/admin/leadform/EditLead';
import EditSupportTicket from './pages/admin/supporttickets/EditSupportTicket';
import ProfileSidebar from './pages/Profile/ProfileSidebar';
import UserSupportTickets from './pages/admin/supporttickets/UserSupportTickets';
import Profile from './pages/Profile/Profile';

import MyCoursesPage from './pages/Profile/MyCoursesPage';
import Documentation from './pages/Profile/Documentation';
import MessagesCard from './pages/Profile/MessagesCard';
import StudyAbroad from './pages/webpages/StudyAbroad/StudyAbroad';
// import WorkPermit from './pages/webpages/WorkPermit';
import { AboutCountryAustralia } from './pages/webpages/StudyAbroad/AustraliaUniversities';
import { AboutCountryEurope } from './pages/webpages/StudyAbroad/EuropeUniversities';
import { AboutCountryIreland } from './pages/webpages/StudyAbroad/IrelandUniversities';
import { AboutCountryNewZealand } from './pages/webpages/StudyAbroad/NewZealandUniversities';
import { AboutCountryUk } from './pages/webpages/StudyAbroad/UkUniversities';
import { AboutCountryUsa } from './pages/webpages/StudyAbroad/UsaUniversities';
import { AboutCountryCanada } from './pages/webpages/StudyAbroad/CanadaUniversities';
import OnlinePayment from './pages/webpages/OnlinePayment';
import Sop from './pages/webpages/Sop';
import Unit1 from './pages/Courses/Unit-1';
import ForgotPasswordPage from './pages/admin/users/ForgotPassword';
import ResendVerification from './pages/admin/users/ResendVerification';
import EditLessonPage from './pages/admin/lesson/EditLesson';
import AddLessonPage from './pages/admin/lesson/CreateLesson';
import EditCoursePage from './pages/admin/course/EditCourse';
import MasterLogin from './pages/Masterpanel';
import ResetPasswordPage from './pages/admin/users/ResetPasswordPage';
import PaymentStatus from './pages/PaymentStatus';
import CourseLearningPage from './pages/admin/course/CourseLearningPage';
import EditOrder from './pages/admin/dashboard/EditOrder';
import VerifyEmail from './pages/admin/users/VerifyEmail';
import CourseResult from './pages/admin/course/CourseResult';
import AboutCountryDubai from './pages/webpages/StudyAbroad/DubaiUniversities';
import CourseDetailPage from './pages/admin/course/CourseDetailPage';
import AllCourses from './pages/admin/course/AllCourses';
import AdminReplyTicket from './pages/admin/supporttickets/AdminSupportTicket';
import MyOrdersPage from './pages/Profile/MyOrdersPage';
import Certificates from './pages/Profile/Certificates';
import UserTicketChat from './pages/Profile/UserTicketChat';

// Admin Protection
const ProtectedAdminRoute = ({ children }) => {
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const { isLoading } = useLoadUserQuery(undefined, {
    skip: isAuthenticated,
  });

  if (isLoading) return <div>Loading...</div>;
  if (!isAuthenticated || !["admin", "instructor", "student", "client", "user"].includes(user?.role)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  const { user } = useSelector((store) => store.auth);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<MainLayout />}>
          <Route index element={<><HeroSection /><PopularService /><HomeAbout /></>} />
          <Route path="/master-panel" element={<MasterLogin />} />
          <Route path="login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/resend-verification" element={<ResendVerification />} />
          <Route path="/verify-email/:token" element={<VerifyEmail />} />
          <Route path="my-learning" element={<MyLearning />} />
          <Route path="support" element={<SupportTicketForm />} />
          <Route path="blog" element={<BlogList />} />
          <Route path="blog/:slug" element={<PostView />} />
          <Route path="courses" element={<AllCourses />} />
          <Route path="courses/:slug" element={<CourseDetailPage />} />
          <Route path=":slug" element={<PageView />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/online-payment" element={<OnlinePayment />} />
          <Route path="/payment/callback" element={<PaymentStatus />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="/unit-1a" element={<Unit1A />} />
          <Route path="/become-partner" element={<BecomePartnerForm />} />
          <Route path="testimonial" element={<Testimonial />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="study-abroad" element={<StudyAbroad />} />
          <Route path="study-abroad/australia" element={<AboutCountryAustralia />} />
          <Route path="study-abroad/europe" element={<AboutCountryEurope />} />
          <Route path="study-abroad/ireland" element={<AboutCountryIreland />} />
          <Route path="study-abroad/new-zealand" element={<AboutCountryNewZealand />} />
          <Route path="study-abroad/united-kingdom" element={<AboutCountryUk />} />
          <Route path="study-abroad/united-states" element={<AboutCountryUsa />} />
          <Route path="study-abroad/dubai" element={<AboutCountryDubai />} />

          <Route path="canadastudy-abroad/" element={<AboutCountryCanada />} />
          {/* <Route path="work-permit" element={<WorkPermit />} /> */}
          <Route path="sop" element={<Sop />} />
          <Route path="mock" element={<MockTestsPage />} />
          <Route path="courses/:slug/learn" element={<CourseLearningPage />} />
              <Route path="courses/:courseSlug/result" element={<CourseResult />} />

        </Route>

        {/* Admin and Instructor Access Routes */}
        <Route
          path="/admin"
          element={
            <ProtectedAdminRoute>
              <Sidebar />
            </ProtectedAdminRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />

          {user?.role === "admin" && (
            <>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="orders/:id/edit" element={<EditOrder />} /> 
              <Route path="courses" element={<CoursesList />} />
              <Route path="courses/create" element={<CreateCourse />} />
              <Route path="courses/:courseSlug/edit" element={<EditCoursePage />} />
              <Route path="courses/:courseSlug/add-lesson" element={<AddLessonPage />} />
              <Route path="courses/:courseSlug/lessons/:lessonId" element={<EditLessonPage />} />
              <Route path="unit1" element={<Unit1 />} />
              <Route path="pages" element={<PagesList />} />
              <Route path="pages/create" element={<CreatePage />} />
              <Route path="pages/:slug/edit" element={<EditPage />} />
              <Route path="posts" element={<PostsList />} />
              <Route path="posts/create" element={<CreatePost />} />
              <Route path="posts/:slug/edit" element={<EditPost />} />
              <Route path="mails" element={<EmailDashboard />} />
              <Route path="users" element={<UserList />} />
              <Route path="users/create" element={<CreateUser />} />
              <Route path="edit-user/:id" element={<EditUser />} />
            </>
          )}

          {(user?.role === "admin" || user?.role === "instructor") && (
            <>
              <Route path="newsflash" element={<NewsFlashAdmin />} />
              <Route path="support/list" element={<SupportList />} />
              <Route path="support/edit/:id" element={<EditSupportTicket />} />
              <Route path="support/reply/:id" element={<AdminReplyTicket />} />
              <Route path="invoices" element={<InvoiceList />} />
              <Route path="invoices/create" element={<InvoiceForm />} />
              <Route path="invoices/:invoiceNo/edit" element={<InvoiceEdit />} />
              <Route path="attendance" element={<Attendance />} />
              <Route path="leads" element={<LeadList />} />
              <Route path="leads/create" element={<AddNewLeads />} />
              <Route path="leads/edit/:id" element={<EditLead />} />
              <Route path="orders" element={<OrdersList />} />
              <Route path="partner-list" element={<PartnerList />} />
              <Route path="partners/create" element={<CreatePartner />} />
              <Route path="partners/:id" element={<EditPartnerDetails />} />
            </>
          )}
        </Route>

        {/* Dashboard for All Authenticated Users */}
        <Route
          path="/dashboard/"
          element={
            <ProtectedAdminRoute>
              <ProfileSidebar />
            </ProtectedAdminRoute>
          }
        >
          <Route path="profile" element={<Profile />} />
          <Route path="support" element={<UserSupportTickets />} />
          <Route path="support/:id" element={<UserTicketChat />} />
          <Route path="support/reply/:id" element={<AdminReplyTicket />} />
          <Route path="myorders" element={<MyOrdersPage />} />
          <Route path="certificates" element={<Certificates />} />

          {user && ["student", "admin", "instructor"].includes(user.role) && (
            <Route path="mycourses" element={<MyCoursesPage />} />
          )}
          {/* {user && ["client", "admin", "instructor"].includes(user.role) && (
            <Route path="documentation" element={<Documentation />} />
          )} */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;